// Static content for the "Business Overview" tab's cards.
// Each entry needs a unique slug so it can route to its own detail page,
// exactly like products/offerings/partners do via the API.
export const OVERVIEW_ITEMS = [
  {
    slug: "business-scope",
    title: "Business Scope",
    image: "/images/overview/business-scope.jpg",
    description:
      "Services for SMEs to large global enterprises — IT services, consultancy, and hardware/software products, tailor-made to combine industry knowledge with client needs.",
    detailed_description:
      "Write the full, longer-form static copy for this page here. This can be a few paragraphs — it renders on the detail page the same way `product.detailed_description` does on ProductDetailPage.",
  },
  {
    slug: "workplace-culture",
    title: "Workplace Culture",
    image: "/images/overview/workplace-culture.jpg",
    description:
      "A commitment to continuous skills development and training fosters a productive, vibrant and growing workforce, aligning employee growth with technological advancement.",
    detailed_description:
      "Full static detail copy for Workplace Culture goes here.",
  },
  {
    slug: "our-purpose",
    title: "Our Purpose",
    image: "/images/overview/our-purpose.jpg",
    description:
      "A leader in the IT industry with unique, customized services — focused on long-term client relationships, delivering value, and empowering businesses through innovation.",
    detailed_description:
      "Full static detail copy for Our Purpose goes here.",
  },
];

export const getOverviewItemBySlug = (slug) =>
  OVERVIEW_ITEMS.find((item) => item.slug === slug);